import React from 'react';
import pipelineModel from './model/pipelineModel';
import { SelectBasePrototype } from 'clad';

export const SelectPipelineType = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder } = props;
    const handleFetch = () => pipelineModel.listPipelineType();

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a pipeline type')}
            schema={{ idOption: 'id', option: 'name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
        />
    );
});
